import {
  Box,
  Card,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import React, { useEffect, useState } from "react";

interface URLImageTabProps {
  onSelectImage: (url: string, attribution?: string) => void;
  initialUrl?: string;
}

export const URLImageTab: React.FC<URLImageTabProps> = ({ 
  onSelectImage,
  initialUrl = ""
}) => {
  const [url, setUrl] = useState(initialUrl);

  useEffect(() => {
    if (url && (url.startsWith('http://') || url.startsWith('https://'))) {
      onSelectImage(url, "");
    } else {
      onSelectImage("", "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  const isValidUrl = url && (url.startsWith('http://') || url.startsWith('https://'));

  return (
    <Stack spacing={3}>
      <Typography variant="body2" color="text.secondary">
        Preview and insert an image from the web. Image must be publicly accessible.
      </Typography>

      <TextField
        variant="outlined"
        placeholder="https://example.com/image.jpg"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <LinkIcon />
            </InputAdornment>
          ),
        }}
        helperText={url && !isValidUrl ? "URL must start with http:// or https://" : "Paste a direct image URL to preview it"}
        error={url !== "" && !isValidUrl}
      />

      {isValidUrl && (
        <Card sx={{ mt: 2 }}>
          <Box sx={{ p: 3 }}>
            <img
              src={url}
              alt="Preview"
              style={{
                maxHeight: 300,
                width: '100%',
                objectFit: 'contain',
                borderRadius: 4,
              }}
            />
          </Box>
        </Card>
      )}
    </Stack>
  );
};